import { SelectDropdown } from "@/components";
import React, { useContext, useMemo } from "react";
import { string, bool, object, func, oneOf } from "prop-types";
import { useCountries } from "@/hooks";
import { useTextDomainContext } from "@/app/providers";

export const CountryDropdown = (props: any) => {
  const {
    cacheKey,
    required,
    sx,
    refetch,
    refetched,
    currentTeam,
    currentSubsidiary,
  } = props;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const { countries: options } = useCountries(currentTeam, currentSubsidiary);

  //#region useMemo
  const componentLabel = useMemo(() => {
    let label = gettext("Country");
    if (typeof props.componentLabel !== "undefined") {
      label = props.componentLabel;
    }
    return label;
  }, [gettext, props.componentLabel]);

  const defaultValue = useMemo(() => {
    let value = undefined;
    if (typeof props.defaultValue !== "undefined") {
      value = props.defaultValue;
    }
    return value;
  }, [props.defaultValue]);
  //#endregion useMemo

  //#region Handlers
  const handleChange = (event: any) => {
    if (event.value !== defaultValue) {
      if (typeof props.onChange === "function") {
        props.onChange(event);
      }
    }
  };
  //#endregion Handlers

  return (
    <SelectDropdown
      options={
        options as unknown as import("@/types/Dropdown.types").DropdownOption[]
      }
      componentLabel={componentLabel}
      defaultValue={defaultValue}
      showAll={props.showAll}
      cacheKey={cacheKey}
      required={required}
      onChange={handleChange}
      refetch={refetch || false}
      refetched={refetched}
      visualStyle="autoComplete"
      sx={{
        ...sx,
      }}
    />
  );
};

CountryDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  currentTeam: string,
  cacheKey: string,
  showAll: bool,
  required: bool,
  sx: object,
  onChange: func,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"]),
  currentSubsidiary: string,
  refetch: bool,
  refetched: func,
};
